import Vue from 'vue'
//import router from '../router';

export default {
    state: {
        skills: [],
        provinces: [],
        policeUnits: [],
        credits: 0,
        loadingSkills: false,
        loadingProvinces: false,
        loadingPoliceUnits: false,
        loadingCredits: false,
        isSmall: window.outerWidth <= 768 ? true : false
    },
    getters: {
        skills: state => state.skills,
        provinces: state => state.provinces,
        policeUnits: state => state.policeUnits,
        credits: state => state.credits,
        isSmall: state => state.isSmall
    },
    actions: {
        SET_SMALL: ({commit, state}) => {
            commit('SET_SMALL', window.outerWidth < 768 ? true : false);
        },
        GET_SKILLS: ({commit, state}) => {
            return new Promise((resolve, reject) => {
                if(state.skills.length > 0)
                    return resolve(state.skills)
                
                if(state.loadingSkills == false)
                {
                    commit('SET_SKILLS_LOADER', true);
                    Vue.http.get('api/Skill').then((res) => {
                        commit('SET_SKILLS', res.data);
                        commit('SET_SKILLS_LOADER', false);
                        return resolve(res.data);
                    }).catch(() => {
                        commit('SET_SKILLS_LOADER', false);
                        return reject();
                    });
                }
            });
        },
        GET_PROVINCES: ({commit, state}) => {
            return new Promise((resolve, reject) => {
                if(state.skills.length > 0)
                    return resolve(state.skills)

                if(state.loadingCredits == false)
                {
                    commit('SET_PROVINCES_LOADER', true);
                    Vue.http.get('api/Province').then((res) => {
                        commit('SET_PROVINCES', res.data);
                        commit('SET_PROVINCES_LOADER', false);
                        return resolve(res.data);
                    }).catch(() => {
                        commit('SET_PROVINCES_LOADER', false);
                        return reject();
                    });
                }
            });
        },
        GET_POLICEUNITS: ({commit, state}) => {
            return new Promise((resolve, reject) => {
                if(state.policeUnits.length > 0)
                    return resolve(state.policeUnits)
                
                if(state.loadingPoliceUnits == false)
                {
                    commit('SET_POLICEUNITS_LOADER', true);
                    Vue.http.get('api/policeunits').then((res) => {
                        commit('SET_POLICEUNITS', res.data);
                        return resolve(res.data);
                    }).catch(() => {
                        return reject();
                    }).finally(() => {
                        commit('SET_POLICEUNITS_LOADER', false);
                    })
                }
            });
        },
        GET_CREDITS: ({commit, state}) => {
            return new Promise((resolve, reject) => {
                if(state.loadingCredits == false)
                {
                    commit('SET_CREDITS_LOADER', true);
                    Vue.http.get('api/Credits').then((res) => {
                        commit('SET_CREDITS', res.data);
                        commit('SET_CREDITS_LOADER', false);
                        return resolve(res.data);
                    }).catch(() => {
                        commit('SET_CREDITS_LOADER', false);
                        return reject();
                    });
                }
            });
        }
    },
    mutations: {
        SET_SMALL: (state, value) => {
            state.isSmall = value;
        },
        SET_SKILLS_LOADER: (state, value) => {
            state.loadingSkills = value;
        },
        SET_PROVINCES_LOADER: (state, value) => {
            state.loadingProvinces = value;
        },
        SET_POLICEUNITS_LOADER: (state, value) => {
            state.loadingPoliceUnits = value;
        },
        SET_CREDITS_LOADER: (state, value) => {
            state.loadingCredits = value;
        },
        SET_SKILLS: (state, skills) => {
            state.skills = skills;
        },
        SET_PROVINCES: (state, provinces) => {
            state.provinces = provinces;
        },
        SET_POLICEUNITS: (state, policeUnits) => {
            state.policeUnits = policeUnits;
        },
        SET_CREDITS: (state, credits) => {
            state.credits = credits;
        },
    }
}